import React, { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { TID } from "@/lib/testIds";

// Counts down to end-of-day (midnight local) — resets daily.
function getSecondsToMidnight() {
  const now = new Date();
  const end = new Date();
  end.setHours(23, 59, 59, 999);
  return Math.max(0, Math.floor((end - now) / 1000));
}

const two = (n) => String(n).padStart(2, "0");

export default function StickyCountdown() {
  const [sec, setSec] = useState(getSecondsToMidnight());
  useEffect(() => {
    const id = setInterval(() => setSec(getSecondsToMidnight()), 1000);
    return () => clearInterval(id);
  }, []);
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  return (
    <div
      data-testid={TID.countdown}
      className="sticky top-0 z-40 w-full bg-gradient-to-r from-[#FF7A00] via-[#FF9420] to-[#FFC107] text-black"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-2 px-3 py-2 text-[13px] font-semibold sm:text-sm">
        <Flame size={16} className="shrink-0" />
        <span className="hidden sm:inline">LIMITED-TIME LAUNCH OFFER</span>
        <span className="sm:hidden">LAUNCH OFFER</span>
        <span className="opacity-70">·</span>
        <span>Ends in</span>
        <span className="rounded-md bg-black/85 px-2 py-0.5 font-mono tabular-nums text-[#FFC107]">
          {two(h)}:{two(m)}:{two(s)}
        </span>
      </div>
    </div>
  );
}
